// Registers public/service-worker.js — required for Chrome/Edge/Android to
// consider this site installable (no service worker = no install prompt,
// ever, regardless of manifest/icons). Production-only, same convention CRA's
// own PWA template uses, so the dev server's hot-reloading is never fighting
// a cached bundle.
export function register() {
  if (process.env.NODE_ENV !== "production" || !("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL}/service-worker.js`)
      .catch((err) => console.error("[PWA] Service worker registration failed:", err));
  });
}
